export const en = {
  "Type": "Type",
  "Folder": "Folder",
  "Dynamic": "Dynamic",
  "Link": "Link",
  "ExternalLink": "External Link",
  "RedirectLink": "Redirect Link",
  "Name": "Name",
  "Url": "Url",
  "ModuleUrl": "Functional Module",
  "Icon": "Icon",
  "MenuApiUrl": "Menu Api Url",
  "HttpUrl": "Url",
  "Description": "Description",
  "Move": "Move",
  "Action": "Action",
  "AddMenu": "Add Menu",
  "EditMenu": "Edit Menu",
  "Export": "Export",
  "Import": "Import",
  "OK": "OK",
  "Cancel": "Cancel",
  "AddTranslation":"Add Translation"
};
